import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, Box, Grid } from '@mui/material';
import { send_request } from '../../../../../utils/Request';
import TriggerNotInSyncWarning from './TriggerNotInSyncWarning';
import { BlackButton, ItemBox, TriggerDescription, TriggerTitle } from '../CommonStyledComponents';
import SkipNextIcon from '@mui/icons-material/SkipNext';

const TriggerFromExternalWorkflowInfo = ({ projectId, componentId }) => {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [componentName, setComponentName] = useState(null);

  const title = <TriggerTitle>Trigger this with an External App</TriggerTitle>;

  useEffect(() => {
    const fetchStatus = async () => {
      setLoading(true);
      try {
        const json = await send_request(
          `component-service/trigger_from_external_app/triggerSyncStatus/${projectId}`,
          {},
          {},
          'GET'
        );
        if (json && Array.isArray(json.data)) {
          const comp = json.data.find(c => c.componentId === componentId);
          if (comp) {
            setStatus(comp.status);
            setError(comp.pipedreamSyncErrorMessage);
            setComponentName(comp.componentName);
          }
        }
      } catch (e) {
        setStatus('ERROR');
        setError('Failed to fetch trigger sync status.');
      }
      setLoading(false);
    };
    if (projectId && componentId) fetchStatus();
  }, [projectId, componentId]);

  if (loading) {
    return (
      <Box>
        {title}
        <Box display="flex" alignItems="center" justifyContent="center" minHeight={60}>
          <CircularProgress size={24} />
        </Box>
      </Box>
    );
  }

  switch (status) {
    case 'NOT_IN_SYNC':
      return (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {title}
          </Grid>
          <Grid item xs={12}>
            <TriggerDescription>
              This trigger is not in sync. External apps will not be able to trigger this workflow
              until it is activated/updated.
            </TriggerDescription>
          </Grid>
          <Grid item xs={12}>
            <TriggerNotInSyncWarning
              syncStatus={[
                { status, pipedreamSyncErrorMessage: error, componentId, componentName },
              ]}
              projectId={projectId}
            />
          </Grid>
        </Grid>
      );
    case 'SYNCED':
      return (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {title}
          </Grid>
          <Grid item xs={12}>
            <TriggerDescription>
              You can trigger this component using the external app you configured
            </TriggerDescription>
          </Grid>
        </Grid>
      );
    default:
      return null;
  }
};

export default TriggerFromExternalWorkflowInfo;
